import { createI18n } from 'vue-i18n';

const supportedLocales = ['en', 'nl', 'de', 'fr', 'es', 'it', 'pt'];

let selectedLocale = 'en';

const savedLocale = localStorage.getItem('locale');
const browserLocale = navigator.language.split('-')[0];

if (savedLocale && supportedLocales.includes(savedLocale)) {
  // Use saved locale from localStorage if available and supported
  selectedLocale = savedLocale;
} else if (supportedLocales.includes(browserLocale)) {
  selectedLocale = browserLocale;
}

// Modify <html> lang
document.documentElement.setAttribute('lang', selectedLocale);

const i18n = createI18n({
  legacy: false,
  locale: selectedLocale,
  // Does this fallbackLocale even work?
  fallbackLocale: 'en',
  missing(locale, key) {
    console.error(`Missing translation: key="${key}" in locale="${locale}"`);
  }
});

const $t = i18n.global.t;

export { i18n, $t };
